/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountConnectionDto,
  CompleteConnectionRequest,
  CompleteEmbeddedSessionRequest,
  CompleteRedirectSessionRequest,
  ConsentStatusResponse,
  GetInstitutionsParams,
  InitiateConnectionRequest,
  InitiateConnectionResponse,
  InitiateEmbeddedSessionRequest,
  InitiateEmbeddedSessionResponse,
  InitiateRedirectSessionRequest,
  InitiateRedirectSessionResponse,
  InitiateSessionRequest,
  InitiateSessionResponse,
  InstitutionDto,
  InstitutionFeaturesResponse,
  OpenBankingPaymentDto,
  PaymentRequest,
  PaymentResponse,
  PaymentSubmissionRequest,
  PaymentSubmissionResponse,
  UpdateAccountActiveFlagPayload,
  UpdateScaMethodRequest,
  UpdateScaMethodResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OpenBankingController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags open-banking-controller
   * @name UpdateYapilyScaMethod
   * @request POST:/api/v1/open-banking/providers/yapily/sessions/update-sca-method
   */
  updateYapilyScaMethod = (data: UpdateScaMethodRequest, params: RequestParams = {}) =>
    this.http.request<UpdateScaMethodResponse, any>({
      path: `/v1/open-banking/providers/yapily/sessions/update-sca-method`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateYapilyScaMethodPath = '/v1/open-banking/providers/yapily/sessions/update-sca-method'
  static updateYapilyScaMethodMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name InitiateYapilyRedirectSession
   * @request POST:/api/v1/open-banking/providers/yapily/sessions/initiate-redirect
   */
  initiateYapilyRedirectSession = (
    data: InitiateRedirectSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<InitiateRedirectSessionResponse, any>({
      path: `/v1/open-banking/providers/yapily/sessions/initiate-redirect`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initiateYapilyRedirectSessionPath =
    '/v1/open-banking/providers/yapily/sessions/initiate-redirect'
  static initiateYapilyRedirectSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name InitiateYapilyEmbeddedSession
   * @request POST:/api/v1/open-banking/providers/yapily/sessions/initiate-embedded
   */
  initiateYapilyEmbeddedSession = (
    data: InitiateEmbeddedSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<InitiateEmbeddedSessionResponse, any>({
      path: `/v1/open-banking/providers/yapily/sessions/initiate-embedded`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initiateYapilyEmbeddedSessionPath =
    '/v1/open-banking/providers/yapily/sessions/initiate-embedded'
  static initiateYapilyEmbeddedSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name CompleteYapilyRedirectSession
   * @request POST:/api/v1/open-banking/providers/yapily/sessions/complete-redirect
   */
  completeYapilyRedirectSession = (
    data: CompleteRedirectSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/providers/yapily/sessions/complete-redirect`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static completeYapilyRedirectSessionPath =
    '/v1/open-banking/providers/yapily/sessions/complete-redirect'
  static completeYapilyRedirectSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name CompleteYapilyEmbeddedSession
   * @request POST:/api/v1/open-banking/providers/yapily/sessions/complete-embedded
   */
  completeYapilyEmbeddedSession = (
    data: CompleteEmbeddedSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/providers/yapily/sessions/complete-embedded`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static completeYapilyEmbeddedSessionPath =
    '/v1/open-banking/providers/yapily/sessions/complete-embedded'
  static completeYapilyEmbeddedSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name CompleteFinApiSession
   * @request POST:/api/v1/open-banking/providers/finapi/sessions/{sessionId}/complete
   */
  completeFinApiSession = (sessionId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/providers/finapi/sessions/${sessionId}/complete`,
      method: 'POST',
      ...params,
    })

  static completeFinApiSessionPath =
    '/v1/open-banking/providers/finapi/sessions/${sessionId}/complete'
  static completeFinApiSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name InitiateFinApiSession
   * @request POST:/api/v1/open-banking/providers/finapi/sessions/initiate
   */
  initiateFinApiSession = (data: InitiateSessionRequest, params: RequestParams = {}) =>
    this.http.request<InitiateSessionResponse, any>({
      path: `/v1/open-banking/providers/finapi/sessions/initiate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initiateFinApiSessionPath = '/v1/open-banking/providers/finapi/sessions/initiate'
  static initiateFinApiSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name PrepareFinapiCreditTransfer
   * @request POST:/api/v1/open-banking/provider/finapi/payments
   */
  prepareFinapiCreditTransfer = (data: PaymentRequest, params: RequestParams = {}) =>
    this.http.request<PaymentResponse, any>({
      path: `/v1/open-banking/provider/finapi/payments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static prepareFinapiCreditTransferPath = '/v1/open-banking/provider/finapi/payments'
  static prepareFinapiCreditTransferMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name SubmitFinapiCreditTransfer
   * @request POST:/api/v1/open-banking/provider/finapi/payments/submit
   */
  submitFinapiCreditTransfer = (data: PaymentSubmissionRequest, params: RequestParams = {}) =>
    this.http.request<PaymentSubmissionResponse, any>({
      path: `/v1/open-banking/provider/finapi/payments/submit`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static submitFinapiCreditTransferPath = '/v1/open-banking/provider/finapi/payments/submit'
  static submitFinapiCreditTransferMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name InitiateConnection
   * @request POST:/api/v1/open-banking/connections/initiate
   * @deprecated
   */
  initiateConnection = (data: InitiateConnectionRequest, params: RequestParams = {}) =>
    this.http.request<InitiateConnectionResponse, any>({
      path: `/v1/open-banking/connections/initiate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initiateConnectionPath = '/v1/open-banking/connections/initiate'
  static initiateConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name CompleteConnection
   * @request POST:/api/v1/open-banking/connections/complete
   * @deprecated
   */
  completeConnection = (data: CompleteConnectionRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/connections/complete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static completeConnectionPath = '/v1/open-banking/connections/complete'
  static completeConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name UpdateAccountActiveFlag
   * @request PATCH:/api/v1/open-banking/bank-accounts/{accountId}/active
   */
  updateAccountActiveFlag = (
    accountId: string,
    data: UpdateAccountActiveFlagPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/bank-accounts/${accountId}/active`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateAccountActiveFlagPath = '/v1/open-banking/bank-accounts/${accountId}/active'
  static updateAccountActiveFlagMethod = 'PATCH'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetYapilyConsentStatus
   * @request GET:/api/v1/open-banking/providers/yapily/sessions/{sessionId}/consent-status
   */
  getYapilyConsentStatus = (sessionId: string, params: RequestParams = {}) =>
    this.http.request<ConsentStatusResponse, any>({
      path: `/v1/open-banking/providers/yapily/sessions/${sessionId}/consent-status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getYapilyConsentStatusPath =
    '/v1/open-banking/providers/yapily/sessions/${sessionId}/consent-status'
  static getYapilyConsentStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetYapilyInstitutionFeatures
   * @request GET:/api/v1/open-banking/providers/yapily/institutions/{institutionId}/features
   */
  getYapilyInstitutionFeatures = (institutionId: string, params: RequestParams = {}) =>
    this.http.request<InstitutionFeaturesResponse, any>({
      path: `/v1/open-banking/providers/yapily/institutions/${institutionId}/features`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getYapilyInstitutionFeaturesPath =
    '/v1/open-banking/providers/yapily/institutions/${institutionId}/features'
  static getYapilyInstitutionFeaturesMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name FindOpenBankingPayment
   * @request GET:/api/v1/open-banking/provider/finapi/payments/{paymentId}
   */
  findOpenBankingPayment = (paymentId: string, params: RequestParams = {}) =>
    this.http.request<OpenBankingPaymentDto, any>({
      path: `/v1/open-banking/provider/finapi/payments/${paymentId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findOpenBankingPaymentPath = '/v1/open-banking/provider/finapi/payments/${paymentId}'
  static findOpenBankingPaymentMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetInstitutions
   * @request GET:/api/v1/open-banking/institutions
   */
  getInstitutions = (query: GetInstitutionsParams, params: RequestParams = {}) =>
    this.http.request<InstitutionDto[], any>({
      path: `/v1/open-banking/institutions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getInstitutionsPath = '/v1/open-banking/institutions'
  static getInstitutionsMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name GetAccountConnections
   * @request GET:/api/v1/open-banking/connections
   */
  getAccountConnections = (params: RequestParams = {}) =>
    this.http.request<AccountConnectionDto[], any>({
      path: `/v1/open-banking/connections`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountConnectionsPath = '/v1/open-banking/connections'
  static getAccountConnectionsMethod = 'GET'
  /**
   * No description
   *
   * @tags open-banking-controller
   * @name DeleteAccount
   * @request DELETE:/api/v1/open-banking/providers/{providerType}/bank-accounts/{id}
   * @deprecated
   */
  deleteAccount = (providerType: string, id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/open-banking/providers/${providerType}/bank-accounts/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteAccountPath = '/v1/open-banking/providers/${providerType}/bank-accounts/${id}'
  static deleteAccountMethod = 'DELETE'
}
